import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import GoogleIcon from "@mui/icons-material/Google";
import { useGmailOAuth } from "./useGmailOAuth";

export const GmailConnectionCard: React.FC = () => {
  const {
    connected,
    gmailAddress,
    loading,
    testing,
    handleConnect,
    handleDisconnect,
    handleTest,
  } = useGmailOAuth();

  if (loading) {
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <CircularProgress size={24} />
        <Typography color="text.secondary">
          Checking Gmail connection...
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: connected ? "#22c55e15" : "#6b728015",
          color: connected ? "#22c55e" : "#6b7280",
        }}
      >
        {connected ? <CheckCircleIcon /> : <GoogleIcon />}
      </Box>

      <Box sx={{ flex: 1, minWidth: 200 }}>
        <Typography variant="body2" color="text.secondary">
          Gmail Connection
        </Typography>
        {connected ? (
          <Typography variant="body1" fontWeight={600} color="#22c55e">
            Connected as {gmailAddress}
          </Typography>
        ) : (
          <Typography variant="body1" fontWeight={600} color="#6b7280">
            Gmail Not Connected
          </Typography>
        )}
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        {connected ? (
          <>
            <Button
              variant="outlined"
              size="small"
              onClick={handleTest}
              disabled={testing}
              startIcon={
                testing ? <CircularProgress size={16} /> : undefined
              }
            >
              {testing ? "Testing..." : "Test"}
            </Button>
            <Button
              variant="outlined"
              size="small"
              color="error"
              onClick={handleDisconnect}
              startIcon={<LinkOffIcon />}
            >
              Disconnect
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            size="small"
            onClick={handleConnect}
            startIcon={<GoogleIcon />}
          >
            Connect Gmail
          </Button>
        )}
      </Box>
    </Paper>
  );
};
